import Script from 'next/script';
import { ThirdPartyScriptData } from '../response-data-validator';
interface Props {
  clarityData: ThirdPartyScriptData['clarity'];
}
export const ClarityScript = ({
  clarityData
}: Props) => {
  if (!clarityData.enabled) return null;
  return <Script id='microsoft-clarity' strategy='lazyOnload' dangerouslySetInnerHTML={{
    __html: `(function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityData.config.projectId}");`
  }} data-sentry-element="Script" data-sentry-component="ClarityScript" data-sentry-source-file="clarity.tsx" />;
};